// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.75 2.13525V11.75H12.25V3.4924L21.75 2.13525ZM10.75 4.11655V11.75H2.25V5.51482L10.75 4.11655ZM2.25 13.25H10.75V20.8248L2.25 20.0153V13.25ZM12.25 13.25H21.75V21.8673L12.25 20.4819V13.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-windows-filled')
export default class LogoWindowsFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-windows-filled',
    }
  }
}
